import api from './api';

const dcfService = {
  // Get all DCFs for a report
  getByReport: async (reportId) => {
    const response = await api.get(`/dcf/report/${reportId}`);
    return response.data;
  },

  // Get a single DCF
  getById: async (dcfId) => {
    const response = await api.get(`/dcf/${dcfId}`);
    return response.data;
  },

  // Create a new DCF
  create: async (dcfData) => {
    const response = await api.post('/dcf', dcfData);
    return response.data;
  },

  // Update a DCF
  update: async (dcfId, dcfData) => {
    const response = await api.post(`/dcf/${dcfId}`, dcfData);
    return response.data;
  },

  // Respond to a DCF
  respond: async (dcfId, response) => {
    const responseData = await api.post(`/dcf/${dcfId}/respond`, { response });
    return responseData.data;
  },

  // Close a DCF
  close: async (dcfId) => {
    const response = await api.post(`/dcf/${dcfId}/close`);
    return response.data;
  },

  // Delete a DCF
  delete: async (dcfId) => {
    const response = await api.post(`/dcf/${dcfId}`);
    return response.data;
  },
};

export default dcfService;
